import * as d3 from 'd3'

export default {
  methods: {

    chart_Router() {

      // Canvas Group
      this.canvasChart = this.svg
      .append('g')
      .attr('transform', `translate(0, 0)`)

      this.chart.list.forEach((d,i)=> {
        
        this.primary.axis =   null
        this.primary.max =    null
        this.secondary.axis = null
        this.secondary.max =  null
        
        let chtData = this.chartData.filter(f=> f[this.chart.refCode] == d.name)

        this.set_maxValue(chtData) //-----> below
        this.draw_ChartCanvas(d) //-----> draw_ChartCanvas.js
        this.draw_Timeline(chtData, d)

        this.chart_Controller(chtData, d)
      })
      

      if (this.sundries) {
        let sunData = this.JQueries.sundriesConfig && this.JQueries.sundriesConfig.SQL ? this.Queries[this.JQueries.sundriesConfig.SQL][0] : this.DataItems[0]
        if(this.sundries.length > 0) this.gmx_Sundries(this.svg, this.sundries, sunData, this.JQueries.sundriesConfig.server)
      }
      
    },



    set_maxValue(chtDate) {

      // Setting Primary --------------------------------------------------------
      let maxArray = []
      this.chart.styles.filter(f=> f.type == 'BAR').forEach(s => {
        maxArray.push(d3.max(chtDate, c => c[s.code]))
      })

      this.primary.max = d3.max(maxArray)
      if(this.primary.max == 0) this.secondary.max = 25; else this.primary.max = this.gmx_maxBound5(this.primary.max)

      this.primary.max = this.gmx_maxBound5(this.primary.max)
      this.primary.axis = d3.scaleLinear()
      .domain([0, this.primary.max])
      .range([0, this.chart.height])
      this.primary.titleX = -this.primary.padding

      // Setting secondary ------------------------------------------------------
      let val = null
      let unit = this.secondary.unit.substr(this.secondary.unit.length-1, 1)
      if(unit == '%') {
        val = this.secondary.unit.substr(0,this.secondary.unit.length-1)
        this.secondary.unit = '%'
      }

      if(unit == '%' && val) {
        this.secondary.max = val
      } else {
        maxArray = []
        this.chart.styles.filter(f=> f.type == 'LINE').forEach(s => {
          maxArray.push(d3.max(chtDate, c => c[s.code]))
        })
        this.secondary.max = d3.max(maxArray)
        if(this.secondary.max == 0) this.secondary.max = 25; else this.secondary.max = this.gmx_maxBound5(this.secondary.max)
      }
      
      this.secondary.axis = d3.scaleLinear()
      .domain([0, this.secondary.max])
      .range([this.chart.height, 0])
      this.secondary.titleX = this.chart.width + this.secondary.padding
    }

  }
}
           